import { useBopayOnboardingCanvas } from "./useBopayCanvas";

/**
 * Renders nothing; applies the `bopay-onbo-body` canvas class for as long as
 * it is mounted.
 *
 * Mounted alongside the logged-out routes rather than inside
 * BoPaymentWrapper, because those screens mount the wrapper only above 767px
 * — hooking the wrapper would leave them unstyled on mobile.
 */
export default function BopayOnboardingCanvas() {
  useBopayOnboardingCanvas();
  return null;
}
